import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@app/directives/directives.module';
import { BreakpointAliasPipe } from '@app/pipes/breakpoint-alias.pipe';
import { PipesModule } from '@app/pipes/pipes.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@Component({
  selector: 'app-channel-managers',
  standalone: true,
  imports: [NgOptimizedImage, AngularSvgIconModule, RouterModule, PipesModule, CommonModule, DirectivesModule, InfiniteScrollModule, BreakpointAliasPipe],
  templateUrl: './channel-managers.component.html',
  styleUrl: './channel-managers.component.scss',
  changeDetection: ChangeDetectionStrategy.Default
})
export class ChannelManagersComponent {

  @ViewChild('scroller') public scroller: ElementRef;

  public logos = [
    {
      name: 'siteminder',
      url: 'assets/images/siteminder-negative.png',
      width: 260
    },
    {
      name: 'frontdesk-master',
      url: 'assets/images/fdm-negative.png',
      width: 262
    },
    {
      name: 'octorate',
      url: 'assets/images/octorate-negative.png',
      width: 270
    },
    {
      name: 'cloudbeds',
      url: 'assets/images/cloudbeds-negative.png',
      width: 310
    },
    {
      name: 'cubulis',
      url: 'assets/images/cubulis-negative.png',
      width: 207
    },
    {
      name: 'primalres',
      url: 'assets/images/primalres-negative.png',
      width: 263
    },
    {
      name: 'sabeapp',
      url: 'assets/images/sabeapp-negative.png',
      width: 236
    },
    {
      name: 'mews',
      url: 'assets/images/mews-negative.png',
      width: 219
    },
    {
      name: 'assd',
      url: 'assets/images/assd-negative.png',
      width: 136
    },
    {
      name: 'channex',
      url: 'assets/images/channex-negative.png',
      width: 272
    },
    {
      name: 'room-raccoon',
      url: 'assets/images/room-raccoon-negative.png',
      width: 316
    },
    {
      name: 'siteminder',
      url: 'assets/images/siteminder-negative.png',
      width: 260
    },
    {
      name: 'frontdesk-master',
      url: 'assets/images/fdm-negative.png',
      width: 262
    },
    {
      name: 'octorate',
      url: 'assets/images/octorate-negative.png',
      width: 270
    },
    {
      name: 'cloudbeds',
      url: 'assets/images/cloudbeds-negative.png',
      width: 310
    },
    {
      name: 'cubulis',
      url: 'assets/images/cubulis-negative.png',
      width: 207
    },
    {
      name: 'primalres',
      url: 'assets/images/primalres-negative.png',
      width: 263
    },
    {
      name: 'sabeapp',
      url: 'assets/images/sabeapp-negative.png',
      width: 236
    },
    {
      name: 'mews',
      url: 'assets/images/mews-negative.png',
      width: 219
    },
    {
      name: 'assd',
      url: 'assets/images/assd-negative.png',
      width: 136
    },
    {
      name: 'channex',
      url: 'assets/images/channex-negative.png',
      width: 272
    },
    {
      name: 'room-raccoon',
      url: 'assets/images/room-raccoon-negative.png',
      width: 316
    },
    {
      name: 'siteminder',
      url: 'assets/images/siteminder-negative.png',
      width: 260
    },
    {
      name: 'frontdesk-master',
      url: 'assets/images/fdm-negative.png',
      width: 262
    },
    {
      name: 'octorate',
      url: 'assets/images/octorate-negative.png',
      width: 270
    },
    {
      name: 'cloudbeds',
      url: 'assets/images/cloudbeds-negative.png',
      width: 310
    },
    {
      name: 'cubulis',
      url: 'assets/images/cubulis-negative.png',
      width: 207
    },
    {
      name: 'primalres',
      url: 'assets/images/primalres-negative.png',
      width: 263
    },
    {
      name: 'sabeapp',
      url: 'assets/images/sabeapp-negative.png',
      width: 236
    },
    {
      name: 'mews',
      url: 'assets/images/mews-negative.png',
      width: 219
    },
    {
      name: 'assd',
      url: 'assets/images/assd-negative.png',
      width: 136
    },
    {
      name: 'channex',
      url: 'assets/images/channex-negative.png',
      width: 272
    },
    {
      name: 'room-raccoon',
      url: 'assets/images/room-raccoon-negative.png',
      width: 316
    },
    {
      name: 'siteminder',
      url: 'assets/images/siteminder-negative.png',
      width: 260
    },
    {
      name: 'frontdesk-master',
      url: 'assets/images/fdm-negative.png',
      width: 262
    },
    {
      name: 'octorate',
      url: 'assets/images/octorate-negative.png',
      width: 270
    },
    {
      name: 'cloudbeds',
      url: 'assets/images/cloudbeds-negative.png',
      width: 310
    },
    {
      name: 'cubulis',
      url: 'assets/images/cubulis-negative.png',
      width: 207
    },
    {
      name: 'primalres',
      url: 'assets/images/primalres-negative.png',
      width: 263
    },
    {
      name: 'sabeapp',
      url: 'assets/images/sabeapp-negative.png',
      width: 236
    },
    {
      name: 'mews',
      url: 'assets/images/mews-negative.png',
      width: 219
    },
    {
      name: 'assd',
      url: 'assets/images/assd-negative.png',
      width: 136
    },
    {
      name: 'channex',
      url: 'assets/images/channex-negative.png',
      width: 272
    },
    {
      name: 'room-raccoon',
      url: 'assets/images/room-raccoon-negative.png',
      width: 316
    },

  ];

  ngAfterViewInit() {
    this.scroller.nativeElement.scrollLeft += 1000;
  }

  onScroll($event: any) {
    let threshold;
    let offsetFactor;

    if (window.innerWidth > 980) {
      threshold = 400;
      offsetFactor = 1;
    } else if (window.innerWidth > 500) {
      threshold = 400;
      offsetFactor = 0.75;
    } else {
      threshold = 30;
      offsetFactor = 0.5;
    }

    if ($event.target.scrollLeft <= threshold) {
      const logo = this.logos[this.logos.length - 1]
      const offset = logo.width * offsetFactor;
      this.logos.unshift(logo);
      this.logos.pop();
      // $event.target.scrollLeft += $event.target.scrollLeft;
      $event.target.scrollLeft += Math.max($event.target.scrollLeft, offset);
    } else if ($event.target.scrollLeft > ($event.target.scrollWidth - window.innerWidth - threshold)) {
      const logo = this.logos[0];
      const offset = logo.width * offsetFactor;
      this.logos.push(logo);
      this.logos.shift();
      // $event.target.scrollLeft -= $event.target.scrollLeft;
      $event.target.scrollLeft -= Math.max($event.target.scrollLeft, offset);
      // $event.target.scrollLeft -= offset;
    }
  }
}
